<template>
  <div class="project">
    <advertising-figure />
    <div class="inner-page-nav">
      <inner-page-nav />
    </div>
    <div class="inner-page-content">
      <public-title :title="title">
        <span class="sub">Project Visit</span>
      </public-title>

      <!-- <div class="divider">
                <h2 class="tit">项目名称: 这是一个很厉害的项目</h2>
                <span class="time">发布日期: 2022-1-15</span>
            </div> -->

      <div
        class="pro-list"
        v-for="(item, i) in currentConference.projects"
        :key="i"
      >
        <div class="pro-item">
          <span class="more" @click="handleMore(item)"
            >查看更多详情 <i class="el-icon-d-arrow-right"></i
          ></span>
          <h2 class="tit">{{ item.name }}</h2>
        </div>        
      </div>

      <!-- 项目参观报名放在了会场那了，所以这块注释掉 -->
      <!-- <div class="chose">
        <div class="chose-select">
          <span>您已报名以下项目：</span>
          <div class="test" v-for="(item, i) in signupedlist" :key="i">
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="chose">
        <div class="chose-select">
          <span v-if="!isProjectVisits">报名参观</span>
          <chose-select
            v-if="!isProjectVisits"
            :options="options"
            @input="handleChange"
            :disabled="isProjectVisits"
            :value="selectValue"
          />

          <el-button v-if="!isProjectVisits" type="primary" class="sign-up" @click="handleSignUp"
            >我要报名</el-button
          >
          <el-button v-else type="primary" class="sign-up" style="background: #666;"
            >已完成报名</el-button
          >
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
  import AdvertisingFigure from "@components/advertising"
  import InnerPageNav from "@components/tool-nav"
  import publicTitle from "@components/title"

  import ChoseSelect from "@components/singleSelect"
  import CurrentUserMixin from "@/mixin/CurrentUser"
  import CurrentConferMixin from "@/mixin/CurrentConference"

  export default {
    name: "ProjectVisitPage",
    components: {
      AdvertisingFigure,
      InnerPageNav,
      publicTitle,
      ChoseSelect,
    },
    mixins: [CurrentUserMixin, CurrentConferMixin],
    data() {
      return {
        title: "项目参观",
        // options: [
        //     {
        //         value: 1,
        //         label: "项目一",
        //     },
        //     {
        //         value: 2,
        //         label: "项目二",
        //     },
        //     {
        //         value: 3,
        //         label: "项目三",
        //     },
        // ],
        selectValue: "",
        signupedlist: [],
      }
    },
    computed: {
      options() {
        var newArr = []
        if (this.currentConference.projects) {
          var newArr = this.currentConference.projects.map(function (
            value,
            index
          ) {
            let newvalue = {}
            newvalue.value = value.id
            newvalue.label = value.name
            return newvalue
          })
          return newArr
        }
      },
      isProjectVisits(){
        // 是否报名了项目参观
        if(this.signupedlist && this.signupedlist.length>0){
            return true
        }else{
            return false
        }
      }
    },
    watch: {
      currentSignup: {
        handler(val) {
          this.signupedlist = val.projectvisits
        },
        deep: true,
      },
    },
    created() {
      if (this.currentSignup) {
        this.signupedlist = this.currentSignup.projectvisits
      }
    },
    methods: {
      handleChange(val) {
        // let currentValue = this.options.filter((item, idx) => {
        //     return item.value == val;
        // });
        // this.selectValue = currentValue[0].value;
        this.selectValue = val
      },

      handleSignUp() {
        if (this.currentSignup.phone !== "" && this.selectValue!="") {
          const url = process.env.VUE_APP_API_URL + "api/v1/conference/pvsignup"
          const data = {
            signupid: this.currentSignup.id,
            provisitid: this.selectValue,
          }
          return axios.post(url, data).then((res) => {
            this.$message("申请成功！")
            this.getsign().then((res) => {
              if (res) {
                this.signupedlist = res.projectvisits
              }
            })
            this.selectValue = ""
          })
        }
      },

      handleMore(item) {
        this.$router.push({ name: "ProjectDetail", params: { pv: item } })
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "@assets/scss/innerpagenav.scss";

  .inner-page-nav {
    position: relative;
    width: 1200px;
    height: 60px;
    padding: 0 15px;
    margin: 0 auto;
  }

  .inner-page-content {
    margin: 60px 0;
  }

  .divider {
    @include flex-between;
    width: 1200px;
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    margin: 30px auto 60px;
    border-bottom: 1px solid #eee;

    .tit {
      position: relative;
      font-size: 18px;
      color: #666;

      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 30px;
        height: 2px;
        background: $defaultColor;
      }
    }

    .time {
      font-size: 14px;
      color: #999;
    }
  }

  .pro-list {
    width: 1200px;
    margin: 30px auto;

    .pro-item {
      position: relative;
      padding: 30px;
      margin-bottom: 30px;
      min-height: 180px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);

      .more {
        position: absolute;
        top: 30px;
        right: 30px;
        font-size: 14px;
        color: $defaultColor;
      }

      .tit {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        display: inline-block;
        min-width: 180px;
        font-size: 20px;
        margin: 30px 0;
        color: $defaultColor;
        padding: 0 30px;
        text-align: center;

        &:before {
          content: "";
          position: absolute;
          top: 50%;
          left: -100px;
          width: 100px;
          height: 2px;
          background: linear-gradient(to right, transparent, #ccc);
        }

        &:after {
          content: "";
          position: absolute;
          top: 50%;
          right: -100px;
          width: 100px;
          height: 2px;
          background: linear-gradient(to left, transparent, #ccc);
        }
      }

      .article-wrap {
        .article {
          margin-top: 30px;
          padding-bottom: 15px;
          border-bottom: 1px solid #eee;

          .sub-tit {
            font-size: 16px;
            margin-bottom: 10px;
            color: $defaultColor;
          }

          .info {
            font-size: 14px;
            line-height: 30px;
            color: #666;
          }
        }
      }
    }
  }
  .test {
    font-size: 10px;
    color: $defaultColor;
  }
  .chose {
    text-align: center;

    .chose-select {
      display: inline-block;
      margin-top: 15px;

      span {
        font-size: 14px;
        color: $defaultColor;
        padding: 0 15px;
      }
    }

    .sign-up {
      display: block;
      width: 120px;
      margin: 30px auto 0;
    }
  }
</style>
